import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type ProductsGeneralFlatTeamSettingGroupId =
  | "products_general.hazmat"
  | "products_general.product_transform";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason:
    "Product-level settings including hazmat and product attribute definitions.",
};

export const ProductsGeneralFlatTeamSettingGroups = [
  {
    id: "products_general.hazmat",
    title: "Hazmat",
    description: "Hazmat settings on the Products general page.",
    productArea: "general",
    access: directMerchantAccess(SettingsPermissions.SET_GENERAL_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "products" },
    synonyms: ["hazmat", "products general"],
  },
  {
    id: "products_general.product_transform",
    title: "Transform product",
    description:
      "Map returned products to other SKUs so they can be resold as a different item.",
    productArea: "general",
    access: directMerchantAccess(SettingsPermissions.SET_GENERAL_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "product-transform" },
    synonyms: [
      "product transform",
      "transform product",
      "sku transform",
      "resale sku",
    ],
  },
] as const satisfies readonly SettingGroupDefinition<ProductsGeneralFlatTeamSettingGroupId>[];

export const ProductsGeneralFlatTeamSettingGroupById: Record<
  ProductsGeneralFlatTeamSettingGroupId,
  SettingGroupDefinition<ProductsGeneralFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      ProductsGeneralFlatTeamSettingGroupId,
      SettingGroupDefinition<ProductsGeneralFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of ProductsGeneralFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return map as Record<
    ProductsGeneralFlatTeamSettingGroupId,
    SettingGroupDefinition<ProductsGeneralFlatTeamSettingGroupId>
  >;
})();
